export const TABLE_PREFERENCES = {
  TODAY_PATIENT: 'TODAY_PATIENT',
  ALL_PATIENT: 'ALL_PATIENT',
  CUSTOM_FILTER: 'CUSTOM_FILTER',
};

export const AR_TABLE_PREFERENCES = {
  AR_BY_DOS: 'AR_BY_DOS',
  AR_BY_PATIENT: 'AR_BY_PATIENT',
  AR_BY_PAYOR: 'AR_BY_PAYOR',
  AR_BY_PAYOR_DETAILS: 'AR_BY_PAYOR_DETAILS',
  TARGET_LISTS: 'TARGET_LISTS',
  TARGET_LISTS_DETAILS: 'TARGET_LISTS_DETAILS',
  CAMPAIGN: 'CAMPAIGN',
  TARGET_LIST_RESULT: 'TARGET_LIST_RESULT',
  CAMPAIGN_PAID_PATIENTS: 'CAMPAIGN_PAID_PATIENTS',
};

export const TEMPLATE_TABLE_PREFERENCES = {
  PAYMENTS: 'TEMPLATE_PAYMENTS',
  PAYMENT_PLAN: 'TEMPLATE_PAYMENT_PLAN',
  AR_AUTOMATION: 'TEMPLATE_AR_AUTOMATION',
  PRACTICE: 'TEMPLATE_PRACTICE',
  SMS: 'TEMPLATE_SMS',
  EMAIL: 'TEMPLATE_EMAIL',
  CAMPAIGN: 'TEMPLATE_CAMPAIGN',
  COMMUNICATION: 'TEMPLAYE_COMMUNICATION',
  EMAIL_COMMUNICATION: 'TEMPLATE_EMAIL_COMMUNICATION'
};

export const PRACTICE_ASSESSMENT_TABLE_PREFERENCES = {
  ASSESSMENT_DETAILS: 'ASSESSMENT_DETAILS',
  ASSESSMENT_PLAN_DETAILS: 'ASSESSMENT_PLAN_DETAILS',
  ASSESSMENT_CUSTOM_FORM_DETAILS: 'ASSESSMENT_CUSTOM_FORM_DETAILS',
};

export const PATIENT_INFO_TABLE_PREFERENCES = {
  BILLING_SUMMARY: 'BILLING_SUMMARY',
  DOS_VIEW: 'DOS_VIEW',
  PRE_PAYMENT: 'PRE_PAYMENT',
  PAYMENT_PLAN: 'PAYMENT_PLAN',
  PAYMENT_PLAN_PATIENT_INFO: 'PAYMENT_PLAN_PATIENT_INFO',
  FAILED_PAYMENT: 'FAILED_PAYMENT',
  INVOICE: 'INVOICE',
  TRANSACTION_HISTORY: 'TRANSACTION_HISTORY',
  PAYMENTS_TRANSACTIONS: 'PAYMENTS_TRANSACTIONS',
};

export const PRACTICE_INFO_TABLE_PREFERENCES = {
  PRACTICE_INVOICE: 'PRACTICE_INVOICE',
  PRACTICE_TRANSACTION_HISTORY: 'PRACTICE_TRANSACTION_HISTORY'
};
